import { coursesApi } from './courses-base.api';
import type {
	CheckUnsubscribeTokenInput,
	CheckUnsubscribeTokenOutput,
	ProcessUnsubscribeInput,
	ProcessUnsubscribeOutput,
} from '../../types/unsubscribe.types';

// Public endpoints (no sign-in, so `skipAuth`).

export const unsubscribeEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		checkUnsubscribeToken: builder.query<CheckUnsubscribeTokenOutput, CheckUnsubscribeTokenInput>({
			query: (params) => ({ url: 'courses/public/unsubscribe', params }),
			extraOptions: { skipAuth: true },
		}),
		processUnsubscribe: builder.mutation<ProcessUnsubscribeOutput, ProcessUnsubscribeInput>({
			query: (body) => ({ url: 'courses/public/unsubscribe', method: 'POST', body }),
			extraOptions: { skipAuth: true },
		}),
	}),
});

export const { useCheckUnsubscribeTokenQuery, useProcessUnsubscribeMutation } =
	unsubscribeEndpoints;
